var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalLedgerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85417 13.5H11.1458C11.7902 13.5 12.3125 12.9031 12.3125 12.1667V5L10.125 2.5H3.85417C3.2098 2.5 2.6875 3.09692 2.6875 3.83333V12.1667C2.6875 12.9031 3.2098 13.5 3.85417 13.5Z",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 13.3333V9.16667C4.4375 8.98985 4.49896 8.82029 4.60835 8.69526C4.71775 8.57024 4.86612 8.5 5.02083 8.5H9.97917C10.1339 8.5 10.2822 8.57024 10.3916 8.69526C10.501 8.82029 10.5625 8.98985 10.5625 9.16667V13.3333M10.125 2.5V6.16667C10.125 6.34348 10.0635 6.51305 9.95415 6.63807C9.84475 6.76309 9.69638 6.83333 9.54167 6.83333H5.02083C4.86612 6.83333 4.71775 6.76309 4.60835 6.63807C4.49896 6.51305 4.4375 6.34348 4.4375 6.16667V2.5M5.89583 10.1667H9.10417M5.89583 11.8333H9.10417",
    stroke: "#FCFAFA",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLedgerIcon);
export default __webpack_public_path__ + "static/media/TotalLedgerIcon.e3e75a6e4f570fefc5bc6c56b38fa310.svg";
export { ForwardRef as ReactComponent };